import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {addStepLog, close_popup, setUrlSinglePageApp} from "../functions";
import {withRouter} from "react-router";

class VehicleActionsPage extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.handleSetPage({name: 'vehicle_actions', params: false});
        this.state = {redirect: ''};

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    handleSetPage(options) {
        if (options.name == 'vehicle_actions')
            addStepLog('Vehicle Actions Page');
        this.props.handleSetPage(options);
    }

    unlockVehicle() {
        addStepLog('Press button Unlock Vehicle on vehicle actions Page')
        this.handleSetPage( {name: 'send_photo', params: {operation: 'unlock'}})
        this.setState({redirect: 'send_photo'})
    }

    findVehicle() {
        addStepLog('Press button Find Vehicle on vehicle actions Page')
        this.setState({redirect: 'find_my_vehicle'})
    }

    render() {
        let t = this;
        if (t.state.redirect === 'send_photo') {
            return  <Redirect push to="/send_photo/unlock/selfie" />;
        } else if (t.state.redirect === 'find_my_vehicle')
            return  <Redirect push to="/find_my_vehicle" />;

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="my-4">What would like to do?</h1>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="offset-2 col-8 text-center">
                        <button type="button" className="base-input green mb-4" onClick={this.unlockVehicle.bind(this)}>
                            Unlock Vehicle
                        </button>
                        <button type="button" className="base-input white mb-4" onClick={this.findVehicle.bind(this)}>
                            Find My Vehicle
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center">
                        <div className="mb-4">
                            <span><b>{this.props.vehicle_data.RegistrationNo}</b></span>
                        </div>
                        <img className={"client_vehicle" + (!this.props.vehicleIsLock ? ' unlocked' : '')} src={this.props.car_image} alt=""/>
                    </div>
                </div>
                {/*<div className="row mr-0">
                    <div className="col-12 mx-2 text-center">
                        <br/>
                        <h2>Unsure about your hire, watch this video!</h2>
                        <div className="d-flex justify-content-center align-items-center">
                            <a target="_blank" href="https://www.youtube.com/watch?v=qhz2pAkoB9M">
                                <div className="play-button"/>
                            </a>
                        </div>
                    </div>
                </div>*/}
            </div>
        </>);
    }
}

const VehicleActionsPageR = withRouter(VehicleActionsPage);
export default VehicleActionsPageR;